import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { 
  Card, Row, Col, Typography, Empty, Spin, 
  Button, message, Tooltip, Tag, Avatar, Input
} from 'antd';
import { 
  TeamOutlined, CrownOutlined, UserOutlined, MailOutlined, SearchOutlined
} from '@ant-design/icons';
import Register from '../components/Register';

const { Title, Text } = Typography;

function TeamList() {

  const [searchValue, setSearchValue] = useState('');
  const [filteredTeam, setFilteredTeam] = useState([]);
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTeamData();
  }, []);

  const fetchTeamData = async () => {

    try {

      setLoading(true);
      const authToken = localStorage.getItem('authToken');
      
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/team_data`, {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      });

      setTeam(response.data.data);
      setFilteredTeam(response.data.data);
      setIsAdmin(localStorage.getItem('userRole') === 'admin');
      setLoading(false);
      
    } catch (error) {

      messageApi.error('Error al cargar los miembros del equipo');
      setLoading(false);

    }

  };

  const handleSearch = (value) => {

    setSearchValue(value);

    const filtered = team.filter(member => {

      const fullName = `${member.firstName} ${member.lastName}`.toLowerCase();
      const username = member.username?.toLowerCase() || '';
      return fullName.includes(value.toLowerCase()) || username.includes(value.toLowerCase());

    });

    setFilteredTeam(filtered);

  };

  const getRoleTag = (role) => {

    const roles = {
      admin: { color: 'gold', icon: <CrownOutlined />, text: 'Admin' },
      moderator: { color: 'blue', icon: <TeamOutlined />, text: 'Moderador' },
      user: { color: 'green', icon: <UserOutlined />, text: 'Usuario' }
    };
    
    const roleData = roles[role] || roles.user;

    return (
      <Tag icon={roleData.icon} color={roleData.color}>
        {roleData.text}
      </Tag>
    );

  };

  const handleEdit = (user) => {

    navigate(`/user_data/${user.id}`);

  };


  if (loading) {

    return (
      <Spin 
        tip="Cargando miembros del equipo..." 
        size="large" 
        style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          marginTop: '20%', 
          color: '#f49b33' 
        }} 
      />
    );
  }

  const getAnimatedTooltipTitle = (fullName) => {

    return (
      <div className="tooltip-carousel">
        <span className="carousel-text">{fullName}</span>
        <span className="carousel-text">{fullName}</span>
      </div>
    );

  };

  return (

    <div style={{ padding: '24px', backgroundColor: '#2a2b2b', minHeight: '100vh' }}>
      {contextHolder}
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <Title level={2} style={{ 
          color: '#f49b33', 
          textAlign: 'center', 
          marginBottom: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <TeamOutlined style={{ marginRight: '12px', fontSize: '28px' }} /> 
          <span>Miembros del Equipo</span>
        </Title>

        {isAdmin && (
          <div style={{ 
            textAlign: 'right', 
            marginBottom: '24px',
            display: 'flex',
            justifyContent: 'flex-end'
          }}>
            <Button 
              type="primary" 
              onClick={() => setShowRegisterModal(true)}
              style={{ 
                backgroundColor: '#f49b33', 
                borderColor: '#f49b33',
                fontWeight: 500,
                padding: '0 24px',
                height: '40px'
              }}
            >
              Agregar Nuevo Miembro
            </Button>
          </div>
        )}

        <div style={{ marginBottom: '24px' }}>
          <Input.Search
            placeholder="Buscar miembro por nombre o usuario..."
            allowClear
            enterButton={<SearchOutlined style={{ color: '#f49b33' }} />}
            size="large"
            value={searchValue}
            onChange={(e) => handleSearch(e.target.value)}
            style={{ 
              maxWidth: '500px', 
              margin: '0 auto',
              display: 'block'
            }}
          />
        </div>

        <Row gutter={[24, 24]} style={{ marginBottom: '24px' }}>
          {filteredTeam.map(member => (
            <Col key={member.id} xs={24} sm={12} md={12} lg={8} xl={6}>
              <Card
                style={{ 
                  backgroundColor: '#353435',
                  borderRadius: '12px',
                  border: 'none',
                  height: '100%',
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
                }}
                bodyStyle={{ 
                  padding: '20px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column'
                }}
                hoverable
                onClick={() => handleEdit(member)}
              >           

                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'column',
                  height: '100%',
                  marginTop: '8px'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    marginBottom: '20px',
                    alignItems: 'flex-start'
                  }}>
                    <Avatar 
                      size={72} 
                      icon={<UserOutlined />}
                      style={{ 
                        backgroundColor: '#f49b33',
                        marginRight: '16px',
                        flexShrink: 0
                      }}
                    />
                    
                    <div style={{ 
                      flex: 1,
                      minWidth: 0,
                      paddingRight: '8px'
                    }}>
                      <Tooltip 
                        title={`${member.firstName} ${member.lastName}`}
                        placement="topLeft"
                      >
                        <Title 
                          level={4}
                          style={{ 
                            color: '#fff', 
                            margin: 0,
                            marginBottom: '4px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            lineHeight: '1.3'
                          }}
                        >
                          {getAnimatedTooltipTitle(`${member.firstName} ${member.lastName}`)}
                        </Title>
                      </Tooltip>
                      
                      <Tooltip title={`@${member.username}`} placement="topLeft">
                        <Text 
                          type="secondary" 
                          style={{ 
                            color: '#aaa',
                            display: 'block',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                        >
                          @{member.username}
                        </Text>
                      </Tooltip>
                      
                      <div style={{ 
                        marginTop: '12px',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '6px'
                      }}>
                        {getRoleTag(member.role)}
                      </div>
                    </div>
                  </div>

                  <div style={{ 
                    marginBottom: '20px',
                    flex: 1
                  }}>
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'flex-start', 
                      marginBottom: '12px'
                    }}>
                      <MailOutlined style={{ 
                        color: '#f49b33', 
                        marginRight: '12px',
                        fontSize: '16px',
                        flexShrink: 0,
                        marginTop: '3px'
                      }} />
                      <Text 
                        style={{ 
                          color: '#fff',
                          wordBreak: 'break-word'
                        }}
                      >
                        {member.email}
                      </Text>
                    </div>
                  </div>

                  <div style={{ 
                    marginTop: 'auto',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end'
                  }}>
                    <div style={{ maxWidth: '70%' }}>
                      <Text type="secondary" style={{ 
                        fontSize: '12px',
                        display: 'block',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: '#fff'
                      }}>
                        Último login: {member.lastLogin ? new Date(member.lastLogin).toLocaleString() : 'Nunca'}
                      </Text>
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        {filteredTeam.length === 0 && (
          <Empty 
            description={<span style={{ color: '#aaa' }}>No hay miembros registrados</span>} 
            style={{ marginTop: '48px' }} 
          />
        )}

      </div>
        
      <style jsx global>{`
        .ant-card {
          transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
        }
        .ant-card:hover {
          transform: translateY(-6px) !important;
          box-shadow: 0 8px 24px rgba(244, 155, 51, 0.2) !important;
        }
        .ant-card .ant-btn-text:not(:hover) {
          color: #aaa;
          opacity: 0.8;
        }
        .ant-card .ant-btn-text:hover {
          background: rgba(255, 255, 255, 0.08) !important;
        }
        .ant-tag {
          margin-right: 0 !important;
        }
        .antd-compat-modal .ant-modal-header {
          border-bottom: 1px solid rgba(255, 77, 79, 0.2);
        }
        .antd-compat-modal .ant-modal-title {
          color: #ff4d4f;
          font-weight: 500;
        }
        .tooltip-carousel {
          display: flex;
          overflow: hidden;
          white-space: nowrap;
          max-width: 300px;
          position: relative;
          height: 30px;
        }
        .carousel-text {
          display: inline-block;
          padding-right: 50px;
          animation: carousel-scroll 10s linear infinite;
        }
        @keyframes carousel-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }

        .ant-modal-content {
          background-color: #353435 !important;
          color: #fff !important;
        }

        .ant-modal-header {
          background-color: #353435 !important;
          border-bottom: 1px solid #444 !important;
        }

        .ant-modal-title {
          color: #f49b33 !important;
        }

        .ant-modal-footer {
          background-color: #353435 !important;
          border-top: 1px solid #444 !important;
        }

        .ant-input,
        .ant-input-password,
        .ant-input-affix-wrapper {
          background-color: #2a2b2b !important;
          color: #fff !important;
          border-color: #555 !important;
        }

        .ant-input::placeholder,
        .ant-input-password input::placeholder {
          color: #aaa !important;
        }
      `}</style>

      <Register 
        visible={showRegisterModal}
        onClose={() => setShowRegisterModal(false)}
        onSuccess={fetchTeamData}
      />


    </div>

  );

}

export default TeamList;